import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledServicesCard,
  StyledServicesCardImg,
  StyledServicesCardText,
  StyledServicesCardBlock,
  StyledServicesCardNew
} from './HomeSectionStyles';
import { useDispatch } from 'react-redux';
import useUserInfo from '../../../components/_hooks/useUserInfo';
import useSimpleModal from '../../../components/_hooks/useSimpleModal';
import { loginModalHandler } from '../../LoginPage/LoginDucks';
import { checkAuth } from '../../../utils/needAuth';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/styles';
import { history } from '../../../_helpers/history';
import { services } from '../../../_helpers/Constants';
import Notice from '../../../modules/utils/Notice';
import SupplierListKindergartenPage from '../../SupplierDataChange/SupplierListKindergartenPage';

const ColorButton = withStyles(() => ({
  root: {
    padding: '10px 20px',
    fontWeight: '700',
    fontSize: '14px',
    textTransform: 'uppercase',
    letterSpacing: '0.01em',
    fontFamily: 'Montserrat',
    '@media (max-width:1000px)': {
      padding: '15px 30px'
    }
  }
}))(Button);

const kindergartenServiceCodes = ['doc_queued_ddo_short', 'doc_acceptance_ddo_short', 'universal_voucher_queue_short'];

function HomeServicesCard({ metadata }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const user = useUserInfo();
  const needAuth = checkAuth(metadata.url);
  const supplierModal = useSimpleModal();
  return (
    <>
      {supplierModal.isOpen && metadata.code === 'supplier_data_change_short' && (
        <SupplierListKindergartenPage modal={supplierModal} />
      )}
      {
        metadata.code === 'government_order_short' || metadata.code === 'service_provider_short' || metadata.code === 'supplier_data_change_short' ?
          (<StyledServicesCard>
          <StyledServicesCardImg>
            <img src={metadata[`img`]} alt={metadata[`${i18n.language}_name`]} />
          </StyledServicesCardImg>
          <StyledServicesCardBlock>
            <StyledServicesCardText children={metadata[`${i18n.language}_name`]} />
            <div>
              {
                (user.username || !needAuth) ?
                  <ColorButton
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                      if (
                        [
                          services.government_order_short.code,
                          services.status_assignment_short.code,
                          services.service_provider_short.code,
                          'supplier_data_change_short'
                        ].includes(metadata.code) && !user.bin
                      ) {
                        return Notice.info(t('serviceCard_forLegalPerson'));
                      }
                      if (metadata.code === 'supplier_data_change_short') {
                        return supplierModal.open(true);
                      }
                      if (!metadata.url) {
                        history.push(`/services/create/${metadata.code}`);
                      } else {
                        history.push(metadata.url);
                      }
                    }}
                    children={['service_provider_short', 'supplier_data_change_short'].includes(metadata.code) ? t('home_submit_application') : t('home_order_service')}
                  />
                  :
                  <ColorButton
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                      if (kindergartenServiceCodes.includes(metadata.code)) {
                        history.push(metadata.url);
                      } else {
                        dispatch(loginModalHandler(true, metadata));
                      }
                    }}
                    children={['service_provider_short', 'supplier_data_change_short'].includes(metadata.code) ? t('home_submit_application') : t('home_order_service')}
                  />
              }
            </div>
          </StyledServicesCardBlock>
        </StyledServicesCard>
      ) : (
        <StyledServicesCard>
          {metadata?.new && <StyledServicesCardNew>new</StyledServicesCardNew>}
          <StyledServicesCardImg>
            <img src={metadata[`img`]} alt={metadata[`${i18n.language}_name`]} />
          </StyledServicesCardImg>
          <StyledServicesCardBlock>
            <StyledServicesCardText children={metadata[`${i18n.language}_name`]} />
            <div>
              {(user.username || !needAuth) ? (
                <ColorButton
                  variant='contained'
                  color='secondary'
                  onClick={() => {
                    if (user.bin) {
                      return Notice.info(t('serviceCard_forPhysicalPerson'));
                    }
                    if (!metadata.url) {
                      history.push(`/services/create/${metadata.code}`);
                    } else {
                      history.push(metadata.url);
                    }
                  }}
                  children={['service_provider_short', 'supplier_data_change_short'].includes(metadata.code) ? t('home_submit_application') : t('home_order_service')}
                />
              ) : (
                <ColorButton
                  variant='contained'
                  color='secondary'
                  onClick={() => {
                    if (kindergartenServiceCodes.includes(metadata.code)) {
                      history.push(metadata.url);
                    } else {
                      dispatch(loginModalHandler(true, metadata));
                    }
                  }}
                  children={['service_provider_short', 'supplier_data_change_short'].includes(metadata.code) ? t('home_submit_application') : t('home_order_service')}
                />
              )}
            </div>
          </StyledServicesCardBlock>
        </StyledServicesCard>
      )}
    </>
  );
}

export default HomeServicesCard;
